import React from 'react';
import {
    User,
    FolderKanban,
    FileImage,
    Plus,
    CheckCircle,
} from "lucide-react";
import {
    UserAvatar,
} from "../DesignShared";

const DesignDetails = ({
    drawing,
    designMembers = [],
    designMembersLoading = false,
    orgMembersLoading = false,
    canDesignAdmin = false,
    setShowAddAssignee,
}) => {
    return (
        <div className="border rounded p-2 bg-white">
            <div className="text-sm font-medium mb-2">Details</div>
            <div className="grid grid-cols-[100px_1fr] gap-y-2 text-sm items-center">
                <div className="flex items-center gap-2 text-xs text-gray-400">
                    <User className="w-3.5 h-3.5" /> Uploaded:
                </div>
                <div className="font-medium text-sm truncate text-gray-900">{drawing.uploadedBy || drawing.uploaded_by}</div>

                <div className="flex items-center gap-2 text-xs text-gray-400">
                    <FolderKanban className="w-3.5 h-3.5" /> Project:
                </div>
                <div className="font-medium text-sm truncate text-gray-900">{drawing.projectName || drawing.project_name}</div>

                <div className="flex items-center gap-2 text-xs text-gray-400">
                    <FileImage className="w-3.5 h-3.5" /> Type:
                </div>
                <div className="font-medium text-sm text-gray-900">{drawing.fileType || drawing.file_type}</div>

                <div className="flex items-center gap-2 text-xs text-gray-400">
                    <User className="w-3.5 h-3.5" /> Assignee:
                </div>
                {/* Assignee Avatar List */}
                <div className="font-medium text-sm">
                    <div className="flex items-center justify-between gap-2">
                        <div className="flex overflow-hidden">
                            {(designMembers || []).length > 0 ? (
                                <div className="flex -space-x-1 items-center gap-2">
                                    <div className="flex -space-x-1 items-center">
                                        {(designMembers || []).slice(0, 4).map((m) => (
                                            <UserAvatar key={m.id} member={m} />
                                        ))}
                                    </div>
                                    {designMembers.length > 4 && (
                                        <span className="text-xs p-1.5 border-[1px] border-white flex flex-row items-center justify-center text-gray-500 rounded-full bg-slate-100">+{designMembers.length - 4}</span>
                                    )}
                                </div>
                            ) : (
                                <span className="truncate text-gray-400">{designMembersLoading ? "Loading..." : "—"}</span>
                            )}
                        </div>
                        <button
                            type="button"
                            className="p-1 border rounded-full hover:bg-sm-primary/80 hover:text-white shrink-0 disabled:opacity-60 transition-colors"
                            title="Add assignee"
                            onClick={() => setShowAddAssignee(true)}
                            disabled={!canDesignAdmin || orgMembersLoading}
                        >
                            <Plus className="w-3.5 h-3.5" />
                        </button>
                    </div>
                </div>

                <div className="flex items-center gap-2 text-xs text-gray-400">
                    <CheckCircle className="w-3.5 h-3.5" /> Approver:
                </div>
                <div className="font-medium text-sm">
                    <div className="flex -space-x-2 overflow-hidden">
                        {(drawing.approverMembers || []).length > 0 ? (
                            (drawing.approverMembers || []).map((m) => (
                                <UserAvatar key={m.id} member={m} />
                            ))
                        ) : (
                            <span className="text-gray-400">—</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DesignDetails;
